export const onPageTransitionEnd = async () => {
  console.log('Page transition end');
};
